import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Firebase Web SDK config for the public story viewer.
//
// SECURITY NOTE: these values are PUBLIC — they identify the project, not
// authenticate the caller. All access control runs through Firestore Security
// Rules (see Infrastructure/firebase/firestore.rules). The viewer makes
// anonymous Firestore reads and the rules permit only:
//   • qrCodes/*  (full read)
//   • stories/*  WHERE isDraft == false
// which is exactly what we want exposed to the world.
//
// Where to find these values:
//   Firebase Console → Project Settings (gear icon) → General →
//   Your apps → Web app → SDK setup and configuration → Config.
//
// If no web app is registered yet, click "Add app" → web (</> icon) and
// register one called "story-viewer". The bucket name should match the iOS
// app's bucket — we share Storage and Firestore across platforms.

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

if (!firebaseConfig.projectId) {
  throw new Error(
    "Firebase config missing. Copy .env.example to .env.local and fill in " +
      "values from Firebase Console → Project Settings → Your apps → Web app."
  );
}

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
